import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface NotificationItem {
  id: string;
  userId: string;
  type: string;
  message: string;
  link: string | null;
  isRead: boolean;
  projectId: string | null;
  createdAt: string;
}

export interface NotificationListResponse {
  items: NotificationItem[];
  total: number;
  unreadCount: number;
}

export async function fetchNotifications(params?: { unreadOnly?: boolean; limit?: number }) {
  const res = await api.get<ApiResponse<NotificationListResponse>>('/notifications', { params });
  return res.data.data!;
}

export async function markNotificationRead(notificationId: string) {
  const res = await api.put<ApiResponse<NotificationItem>>(`/notifications/${notificationId}/read`);
  return res.data.data!;
}

export async function markAllNotificationsRead() {
  const res = await api.put<ApiResponse<{ count: number }>>('/notifications/read-all');
  return res.data.data!;
}
